import React from "react";
import SignIn from "../views/dashboard/auth/sign-in";
import JoinEntry from "../views/dashboard/auth/join";
import OnboardingFlow from "../views/dashboard/auth/onboarding/OnboardingFlow";
import ForgotPasswordFlow from "../views/dashboard/auth/forgot-password/ForgotPasswordFlow";
import Error404 from "../views/dashboard/errors/error404";
import { AuthLandingEntry } from "../features/nemonto";

export const SimpleRouter = [
  {
    path: "auth/sign-in",
    element: <SignIn />,
  },
  {
    path: "auth/sign-up",
    element: <JoinEntry />,
  },
  {
    path: "auth/onboarding",
    element: <OnboardingFlow />,
  },
  {
    path: "auth/forgot-password",
    element: <ForgotPasswordFlow />,
  },
  {
    path: "landing",
    element: <AuthLandingEntry />,
  },
  // Retired here: about-us/privacy-policy/terms-of-use are now only
  // registered under the Default layout (default-router.js), which already
  // renders them chromeless for signed-out visitors and with the full
  // sidebar for signed-in users - having them here too created an
  // ambiguous duplicate-path match.
  {
    path: "errors/error404",
    element: <Error404 />,
  },
  {
    path: "*",
    element: <Error404 />,
  },
];
